import mock from './mock'
import './navbar/navbarSearch'
mock.onAny().passThrough()
